import * as purchase from './purchase';
import * as address from './address';
import * as subscriber from './subscriber';
import * as landlord from './landlord';
import * as icatuCap from './icatuCap';
import * as proposal from './proposal';
import * as bond from './bond';

export default {
    ...purchase,
    ...address,
    ...subscriber,
    ...landlord,
    ...icatuCap,
    ...proposal,
    ...bond,
};
